import { THandleListUpdate } from '@/src/modules/build-a-card/inputs/types'
import { BaseSyntheticEvent } from 'react'

export function handleRecipientChange({
    e,
    key,
    listOfRecipients,
    setListOfRecipients,
    recipientIndex,
}: THandleListUpdate & {
    e: BaseSyntheticEvent
}) {
    const trimmedValue = e.currentTarget.value.trimStart()

    const list = [...listOfRecipients]
    list[recipientIndex][key] = trimmedValue
    setListOfRecipients(list)
}
